import React from 'react';
import SalesList from './SalesList';

const PendingConfirmationsPage = () => {
  return <SalesList defaultTab="pending" />;
};

export default PendingConfirmationsPage;
